// ES6 imports - feel free to write them like this from now on
import PropTypes from 'prop-types';

import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import LocationHelper from '../helpers/location_helper';
import PageSpinner from './shared/page_spinner';
import LogoBar from './ribbons/logo_bar';
import Actions from '../actions/actions';
import Footer from './shared/footer';
import CookiesHelper from '../helpers/auth_helper';
import auth_helper from '../helpers/auth_helper';
import Config from '../config/config';
import { SnackbarProvider } from 'notistack';
import withDataLoaded from './with_data_loaded';
import { userLoaderOptional } from '../actions/data_loaders';
import { Button } from '@mui/material';
import Messages from './ribbons/messages';
import ProposalWizard from './proposal/proposal_wizard';
import CloseIcon from '@mui/icons-material/Close';

import Footnotes from './proposal/footnotes';

// had trouble moving these to lazy...
import { FakeCognitoAuth } from './admin/dashboard/fakeCognitoAuth';
import { CognitoAuth } from './admin/dashboard/cognitoAuth';
import { PendingCognitoAuth } from './admin/dashboard/pendingCognitoAuth';
import { MaintenancePage } from './admin/dashboard/maintenancePage';

import AdminDashboard from './admin/dashboard/admin_dashboard';
import AdminPage from './user_admin/admin_page';
import SignInPerson from './customer/sign_in_person';
import SigningComplete from './customer/signing_complete';
import Modal from './modal/modal';
import MockMosaicEsign from './mocks/mock_mosaic_esign';
import Anchor from './shared/anchor';
import ModalStack from './ribbons/modal_stack';
import CustomerStatusBanner from './customer/customer_status_banner';
import CustomerHistory from './customer_history';

import WelcomeCallErrorPage from './customer/welcome_call/welcome_call_error_page';
import SecurityCenter from './navigation_pages/security_center';
import BorrowerInfo from './proposal/BorrowerInfo';
import UxPage from './ux_page';
import NewProposalPage from './proposal/new_proposal_page';
import Snapshot from './shared/snapshot';
import EnsemblePage from './diagnostic/ensemble_page';
// import UserAlerts from './user_alerts';

const FrDocumentsTier1List = lazy(() => import('./admin/fr_documents/list_tier1' /* webpackChunkName: "RTDR" */));
// const FrDocumentsTier2List = lazy(() => import('./admin/fr_documents/list_tier2' /* webpackChunkName: "RTDR" */));
const FrDocumentsEscalatedList = lazy(() =>
  import('./admin/fr_documents/list_escalated' /* webpackChunkName: "RTDR" */)
);
const FrDocumentsDetails = lazy(() =>
  import('./admin/fr_documents/fr_documents_details' /* webpackChunkName: "RTDR" */)
);
const ReviewCustomerInformation = lazy(() =>
  import('./customer/review_customer_information' /* webpackChunkName: "Eligibility" */)
);

const FailWhalePage = lazy(() => import('./navigation_pages/fail_whale' /* webpackChunkName: "Helpers" */));

const HomeownerPage = lazy(() => import('./homeowner/homeowner_page' /* webpackChunkName: "HomeOwner" */));

const ProposalPage = lazy(() => import('./proposal/proposal_page' /* webpackChunkName: "Helpers" */));

const Stips = lazy(() => import('./customer/stips' /* webpackChunkName: "Eligibility" */));
const HomeownerEligibility = lazy(() =>
  import('./homeowner/homeowner_eligibility' /* webpackChunkName: "HomeOwner" */)
);
const HomeownerEligibilitySubmitted = lazy(() =>
  import('./homeowner/homeowner_eligibility_submitted' /* webpackChunkName: "HomeOwner" */)
);

const ConfirmationPage = lazy(() => import('./customer/confirmation_page' /* webpackChunkName: "Eligibility" */));
const EligibilityStatus = lazy(() => import('./proposal/eligibility_status' /* webpackChunkName: "Eligibility" */));

const QuickCheckPage = lazy(() => import('./quickcheck/quickcheck_page' /* webpackChunkName: "Eligibility" */));
const QuickCheckEnhancedPage = lazy(() =>
  import('./quickcheck/quickcheck_enhanced_page' /* webpackChunkName: "Eligibility" */)
);
const EligibilityStatusPending = lazy(() =>
  import('./proposal/eligibility_status/pending' /* webpackChunkName: "Eligibility" */)
);

const DecisioningTable = lazy(() => import('./admin/decisioning/decision_list' /* webpackChunkName: "Underwriting" */));

const DecisioningPage = lazy(() =>
  import('./admin/decisioning/decision_details' /* webpackChunkName: "Underwriting" */)
);
const QuickCheckStatusWithProposal = lazy(() =>
  import('./quickcheck/quickcheck_status' /* webpackChunkName: "wizard" */)
);

const Scaffold = lazy(() => import('../qaScaffold' /* webpackChunkName: "Scaffold" */));

const AccountDetails = lazy(() => import('./navigation_pages/account_details' /* webpackChunkName: "Admin" */));

const EditUserDetails = lazy(() => import('./user_admin/user_details' /* webpackChunkName: "Admin" */));
const PricingProgramDetails = lazy(() => import('./user_admin/pricing_group_details' /* webpackChunkName: "Admin" */));
const BranchDetails = lazy(() => import('./user_admin/branch_details' /* webpackChunkName: "Admin" */));
const LicenseDetails = lazy(() => import('./user_admin/license_details' /* webpackChunkName: "Admin" */));

const EditCompany = lazy(() => import('./user_admin/company_details' /* webpackChunkName: "Admin" */));

const QuickCheckRemoteCompleted = lazy(() =>
  import('./quickcheck/quickcheck_remote_completed' /* webpackChunkName: "HomeOwner" */)
);

const GeneratingDocumentsPage = lazy(() =>
  import('./proposal/generating_documents_page' /* webpackChunkName: "Helpers" */)
);
const WebHookStatusPage = lazy(() => import('./admin/webhook_status_page' /* webpackChunkName: "Helpers" */));
const SponsorEventsStatusPage = lazy(() =>
  import('./admin/sponsor_events_status_page' /* webpackChunkName: "Helpers" */)
);

const ImpersonationStandByPage = lazy(() =>
  import('./user_admin/impersonation_standby_page' /* webpackChunkName: "Helpers" */)
);
const WelcomeCallPage = lazy(() =>
  import('./customer/welcome_call/welcome_call_page' /* webpackChunkName: "Helpers" */)
);

const NotificationDetails = lazy(() => import('./user_admin/notification_details' /* webpackChunkName: "Helpers" */));
const InfoDisplayPage = lazy(() => import('./info/info_display_page' /* webpackChunkName: "Helpers" */));
const ProductNotAvailable = lazy(() => import('./shared/product_not_available' /* webpackChunkName: "Helpers" */));
const NoStateLicense = lazy(() => import('./shared/no_state_license' /* webpackChunkName: "Helpers" */));

const AuthorizedSignerDetails = lazy(() =>
  import('./user_admin/authorized_signer_details' /* webpackChunkName: "Signature" */)
);
const KbaFailure = lazy(() => import('./proposal/kba_failure' /* webpackChunkName: "Signature" */));
const DownloadPage = lazy(() => import('./documents/download' /* webpackChunkName: "Signature" */));

// inline lazy loading example with pre-fetch:
const CustomerRedirectPage = lazy(() => import('./customer/customer_redirect_page' /* webpackChunkName: "wizard" */));
const SavingsCalculator = lazy(() => import('./customize/savings_calculator' /* webpackChunkName: "wizard" */));
const CollectAddressInformation = lazy(() =>
  import('./customer/collect_address_information' /* webpackChunkName: "wizard" */)
);
const StepDocuments = lazy(() => import('./documents/step_documents' /* webpackChunkName: "wizard" */));
const ProposalRedirectPage = lazy(() => import('./proposal/proposal_redirect_page' /* webpackChunkName: "wizard" */));

const AdvancedCustomersListPage = lazy(() =>
  import('./customers_list/advanced_customers_list/advanced_customers_list_page' /* webpackChunkName: "partner" */)
);

const DisbursementsPage = lazy(() => import('./disbursements/disbursements_page'));

const LoginPage = lazy(() => import('./navigation_pages/login' /* webpackChunkName: "partner" */));
const ResetPassword = lazy(() => import('./reset_password/password_reset_router' /* webpackChunkName: "partner" */));
const MFAPage = lazy(() => import('./mfa_router/mfa_router' /* webpackChunkName: "partner" */));
const TrainingPage = lazy(() => import('./training_router/training_router' /* webpackChunkName: "partner" */));

const AutoPayPreferencesPage = lazy(() => import('./customer/autopay/autopay_preferences_page'));
const AutoPayCompletePage = lazy(() => import('../components/customer/autopay/autopay_complete_page'));

const WelcomeCallCompletePage = lazy(() => import('../components/customer/welcome_call/welcome_call_complete_page'));

const ConfigRouter = lazy(() => import('./config/config_router' /* webpackChunkName: "partner" */));

let { inlineManualEnabled } = Config;

class Page extends Component {
  static propTypes = {
    locks: PropTypes.object.isRequired,
    view: PropTypes.object.isRequired,
    previousView: PropTypes.object,
    proposal: PropTypes.object,
    userPreferredEmail: PropTypes.any,
    user: PropTypes.object,
    userSettingValues: PropTypes.array,
    isGuestUser: PropTypes.bool,
    customer: PropTypes.object,
    eligibility: PropTypes.object,
    esignSrc: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.pageWrapper = React.createRef();

    this.notistackRef = React.createRef();

    window.addEventListener(
      'message',
      (evt) => {
        // console.log('evt', evt);
        if (evt?.origin?.includes('joinmosaic.com') || evt?.origin?.includes('concertfin')) {
          if (evt?.data?.name === 'mosaic:unauthorized') {
            console.log('mosaic:unauthorized');
            Actions.setEsignIframeSrc(null);
          } else if (evt?.data?.name === 'mosaic:complete') {
            console.log('mosaic:complete');
            // if (window.esignUrls[1]) {
            //   window.esignUrls.shift();
            // Actions.setEsignIframeSrc([window.esignUrls[0]]);
            // document.getElementById('esignIframe').src = window.esignUrls[0];
            // } else {
            Actions.setEsignIframeSrc(null);
            // }
          }
          // else {
          //   console.log('evt.data.name', evt?.data?.name);
          // }
        }
        // else {
        //   console.log('evt.origin', evt?.origin);
        // }
      },
      false
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps) return;

    const { user } = prevProps;
    const {
      user: nextPropsUser,
      view: { page: nextPropsPage },
      proposal: nextPropsProposal,
    } = this.props;

    if (inlineManualEnabled && user !== nextPropsUser && nextPropsUser !== null && nextPropsUser !== undefined) {
      Actions.setInlineManualUserTracking(nextPropsUser);
    }

    if (nextPropsPage === 'proposal' && nextPropsProposal && nextPropsProposal.id !== null) {
      Actions.setView({ page: 'proposalRedirect', proposalId: nextPropsProposal.id });
    }
  }

  underWriterPages = [
    'decisioningTable',
    'decisioningTableInactive',
    'decision',
    'fakeCognitoAuth',
    'cognitoAuth',
    'pendingCognitoAuth',
    'maintenancePage',
  ];

  customerPages = [
    'collectCustomerInformation',
    'collectAddressInformation',
    'reviewCustomerInformation',
    'documents',
    'stepDocuments',
    'eligibilityStatus',
    'eligibilityPending',
    'proposal',
    'savingsCalculator',
    'quickCheckStatus',
  ];

  getContent = (loggedIn, isInstallerUser) => {
    let {
      locks: { fetchFunctionalityAcls: userFunctionalityAclsLocked },
      user,
      userSettingValues,
      view: { page, id },
    } = this.props;

    if (window.location.host.indexOf('uw') === 0 && !this.underWriterPages.includes(page)) {
      page = page === 'decisioningTableInactive' ? 'decisioningTableInactive' : 'decisioningTable';
    }

    const queryParams = LocationHelper.searchAsObj();

    switch (page) {
      case 'snapshot':
        return {
          content: <Snapshot />,
          loggedIn: true,
          isProposalPage: false,
        };
      case 'ensembleView':
        return {
          content: <EnsemblePage />,
          loggedIn: true,
          isProposalPage: false,
        };
      case 'mockMosaicEsign':
        return {
          content: <MockMosaicEsign />,
          loggedIn: true,
          isProposalPage: false,
        };
      case 'signingComplete':
        return {
          content: <SigningComplete />,
          loggedIn: false,
          isProposalPage: false,
        };
      case 'signInPerson':
        return {
          content: <SignInPerson />,
          loggedIn: false,
          isProposalPage: false,
        };
      case 'kbaFailure':
        return {
          content: <KbaFailure />,
          loggedIn: false,
          isProposalPage: false,
        };
      case 'collectAddressInformation':
        return {
          content: (
            <div className="proposal-original-container">
              <CollectAddressInformation />
            </div>
          ),
          isProposalPage: true,
        };
      case 'reviewCustomerInformation':
        return {
          content: (
            <div className="proposal-original-container">
              <ReviewCustomerInformation />
            </div>
          ),
          isProposalPage: true,
        };
      // case 'handOff':
      //   return {
      //     content: (
      //       <div className="proposal-original-container">
      //         <HandOff />
      //       </div>
      //     ),
      //     isProposalPage: true,
      //   };
      case 'customersList':
      case 'archivedCustomersList':
        if (typeof userFunctionalityAclsLocked === 'undefined' || userFunctionalityAclsLocked) {
          // userFunctionalityAcls are loaded on page load, so it takes a few ms for userFunctionalityAcls to be loaded
          return {
            content: <PageSpinner />,
            noRibbon: true,
          };
        }
        return {
          content: <AdvancedCustomersListPage pageWrapper={this.pageWrapper} />,
          noRibbon: true,
          hideFooter: true,
        };
      case 'disbursements':
        return typeof userFunctionalityAclsLocked === 'undefined' || userFunctionalityAclsLocked
          ? {
              content: <PageSpinner />,
              noRibbon: true,
            }
          : {
              content: <DisbursementsPage pageWrapper={this.pageWrapper} />,
              noRibbon: true,
              hideFooter: true,
            };
      case 'confirmation':
        return {
          content: <ConfirmationPage />,
        };
      case 'stepDocuments':
        return {
          content: (
            <div className="proposal-original-container" style={{ overflow: 'visible', wordWrap: 'break-spaces' }}>
              <StepDocuments />
            </div>
          ),
          isProposalPage: true,
        };
      case 'eligibilityStatus':
        return {
          content: (
            <div className="proposal-original-container">
              <EligibilityStatus />
            </div>
          ),
          isProposalPage: true,
        };
      case 'eligibilityPending':
        return {
          content: <EligibilityStatusPending />,
          hideFooter: true,
        };
      case 'failWhale':
        return {
          content: <FailWhalePage />,
        };
      case 'download':
        return {
          content: <DownloadPage />,
          loggedIn,
        };
      case 'productNotAvailable':
        return {
          content: <ProductNotAvailable />,
        };
      case 'trainingRequired':
        return {
          content: <TrainingPage />,
        };
      case 'noStateLicense':
        return {
          content: <NoStateLicense />,
        };
      case 'newProposal':
        if (!loggedIn) {
          Actions.setRoute('/login');
        }
        if (this.isCPFUser()) {
          Actions.setRoute('/admin');
        }
        if (!auth_helper.isShortAuth() && !this.props.user) {
          return {
            content: <PageSpinner />,
            loggedIn,
          };
        }

        return queryParams.enhancedRemoteQuickCheck
          ? {
              content: <QuickCheckEnhancedPage />,
              hideFooter: true,
              loggedIn,
            }
          : {
              content:
                userFunctionalityAclsLocked === 'undefined' || userFunctionalityAclsLocked ? (
                  <PageSpinner />
                ) : (
                  <NewProposalPage isInstallerUser={isInstallerUser} />
                ),
              loggedIn,
            };
      case 'newProposalExplicit':
        if (!loggedIn) {
          Actions.setRoute('/login');
        }
        if (!this.props.user) {
          return {
            content: <PageSpinner />,
            loggedIn,
          };
        }
        return {
          content: <NewProposalPage isInstallerUser={isInstallerUser} />,
          loggedIn,
        };
      case 'proposalRedirect':
        return {
          content: <ProposalRedirectPage />,
        };
      case 'generatingDocuments':
        return {
          content: <GeneratingDocumentsPage />,
        };
      case 'savingsCalculator':
        return {
          content: (
            <div className="savings-calculator-container">
              <ProposalPage {...{ eagerLoadFinancingMethod: false }} />
              <SavingsCalculator />
            </div>
          ),
          isProposalPage: true,
          footerFootnotes: true,
        };
      case 'stips':
        return {
          content: <Stips />,
        };
      case 'reloading':
        return undefined;
      case 'resetPassword':
        return {
          content: <ResetPassword />,
          loggedIn: false,
        };
      case 'login':
        if (loggedIn) {
          Actions.setRoute('/');
        }
        return {
          content: <LoginPage />,
          loggedIn,
        };
      case 'homeownerDocuments':
        return {
          content: <HomeownerPage />,
          loggedIn: false,
        };
      case 'homeownerEligibility':
        return {
          content: <HomeownerEligibility />,
          loggedIn: false,
        };
      case 'homeownerEligibilitySubmitted':
        return {
          content: <HomeownerEligibilitySubmitted />,
          loggedIn: false,
        };
      // case 'resume':
      //   return {
      //     content: <ResumeSession />,
      //     loggedIn,
      //   };
      // case 'findProducts':
      //   return {
      //     content: <FindProducts />,
      //     loggedIn,
      //   };
      case 'frDocumentsTier1List':
        return {
          content: <FrDocumentsTier1List {...{ user, userSettingValues }} />,
        };
      // case 'frDocumentsTier2List':
      //   return {
      //     content: <FrDocumentsTier2List {...{ user, userSettingValues }} />,
      //   };
      case 'frDocumentsEscalatedList':
        return {
          content: <FrDocumentsEscalatedList {...{ user, userSettingValues }} />,
        };
      case 'frDocumentsDetails':
        return {
          content: <FrDocumentsDetails />,
        };
      case 'accountDetails':
        return {
          content: <AccountDetails />,
          loggedIn,
        };
      case 'decisioningTable':
      case 'decisioningTableInactive':
        return {
          content: <DecisioningTable />,
          loggedIn: false,
        };
      case 'decision':
        return {
          content: <DecisioningPage />,
          loggedIn: false,
          hideFooter: true,
        };

      case 'webhookStatusPage':
        return {
          content: <WebHookStatusPage />,
          loggedIn: loggedIn,
        };
      case 'sponsorEventsStatusPage':
        return {
          content: <SponsorEventsStatusPage />,
          loggedIn: loggedIn,
        };
      case 'customerRedirectPage':
        return {
          content: <CustomerRedirectPage />,
          loggedIn: loggedIn,
        };

      case 'admin':
        if (!loggedIn || (this.props.user && !this.isCPFUser())) {
          Actions.setRoute('/');
        }
        if (!this.props.user) {
          return {
            content: <PageSpinner />,
            loggedIn,
          };
        }
        return {
          content: <AdminDashboard />, //loggedIn && this.isCPFUser() ? <AdminDashboard/> : <NewProposalOverlay/>,
          loggedIn,
        };

      case 'quickcheck':
        return {
          content: <QuickCheckPage isInstallerUser={isInstallerUser} />,
        };

      case 'quickCheckRemoteCompleted':
        return {
          content: <QuickCheckRemoteCompleted />,
        };

      case 'quickCheckStatus':
        return {
          content: (
            <div className="proposal-original-container">
              <QuickCheckStatusWithProposal />
            </div>
          ),
          isProposalPage: true,
        };
      case 'userList':
        return {
          hideFooter: true,
          content: <AdminPage subPage="users" />,
        };
      case 'companyInfo':
      case 'companyInfoByCompany':
        return {
          content: <AdminPage subPage="company" />,
        };
      case 'companyList':
        return {
          hideFooter: true,
          content: <AdminPage subPage="companies" />,
        };
      case 'branchList':
        return {
          content: <AdminPage subPage="branches" />,
        };
      case 'branchDetails':
        return {
          content: <BranchDetails />,
        };
      case 'notificationList':
        return {
          content: <AdminPage subPage="notifications" />,
        };
      case 'notificationDetails':
        return {
          content: <NotificationDetails />,
        };
      case 'licenseList':
        return {
          content: <AdminPage subPage="licenses" />,
        };
      case 'licenseDetails':
        return {
          content: <LicenseDetails />,
        };

      case 'editUser':
      case 'editUserByCoid':
      case 'newUser':
      case 'newUserByCompany':
        return {
          content: <EditUserDetails />,
        };
      case 'pricingGroupList':
        return {
          content: <AdminPage subPage="pricingGroupList" />,
        };

      case 'pricingGroupDetails':
        return {
          content: <PricingProgramDetails />,
        };

      case 'authorizedSignerList':
        return {
          content: <AdminPage subPage="signers" />,
        };

      case 'authorizedSignerDetails':
        return {
          content: <AuthorizedSignerDetails />,
        };

      case 'companyDetails':
        return {
          content: <EditCompany />,
        };

      case 'infoDisplayPage':
        return {
          content: <InfoDisplayPage />,
          loggedIn: false,
        };

      case 'cognitoAuth':
        return {
          content: <CognitoAuth />,
          loggedIn: false,
        };

      case 'fakeCognitoAuth':
        return {
          content: <FakeCognitoAuth />,
          loggedIn: false,
        };

      case 'pendingCognitoAuth':
        return {
          content: <PendingCognitoAuth />,
          loggedIn: false,
        };
      case 'maintenancePage':
        return {
          content: <MaintenancePage />,
          loggedIn: false,
        };
      case 'impersonationStandByPage':
        return {
          content: <ImpersonationStandByPage />,
        };
      case 'customerHistory':
        return {
          content: <CustomerHistory />,
        };
      case 'welcomeCall':
        return {
          content: <WelcomeCallPage />,
          loggedIn: false,
        };
      case 'welcomeCallErrorPage':
        return {
          content: <WelcomeCallErrorPage />,
          loggedIn: false,
        };
      case 'securityCenter':
        return {
          content: <SecurityCenter />,
          loggedIn: true,
        };
      case 'mfaPage':
        return {
          content: <MFAPage />,
          loggedIn: true,
        };
      case 'welcomeCallCompletePage':
        return {
          content: <WelcomeCallCompletePage />,
          loggedIn: false,
        };
      case 'autoPayCompletePage':
        return {
          content: <AutoPayCompletePage />,
          loggedIn: false,
        };
      case 'autoPayPreferencesPage':
        return {
          content: <AutoPayPreferencesPage />,
          loggedIn: false,
        };
      case 'configRouter':
        return {
          content: <ConfigRouter />,
          hideFooter: true,
          loggedIn: true,
        };
      case 'uxPage':
        return {
          content: <UxPage />,
          hideFooter: true,
          loggedIn: false,
        };
      case 'not-found':
        Actions.setRoute('/');
        // fall through to default
        break;
      case 'borrowerInfo':
        return {
          content: (
            <Modal
              title="Borrower Info"
              container={document.body}
              headerActions={<div></div>}
              customer={{ id: id }}
              footerClass="grey"
              responsive={true}
              financingMethod={null}
            >
              <div className="confirmation-section-wrapper" id={'borrower-modal'}>
                <div className="confirmation-section-message">
                  <div className="confirmation-section-controls-no-pad" style={{ display: 'flex', width: '100%' }}>
                    <BorrowerInfo customerId={id} />
                  </div>
                </div>
              </div>
            </Modal>
          ),

          loggedIn: true,
        };
      default:
        return {
          content: <PageSpinner />,
          loggedIn,
        };
    }
  };

  isCPFUser = () => {
    const { user } = this.props;
    const impersonatedUser = CookiesHelper.getImpersonateCookie();
    return user !== null && user.atype === 'CPF' && !impersonatedUser;
  };

  render() {
    const sessionTokenExists =
      !!CookiesHelper.getSessionToken() || (CookiesHelper.getImpersonateCookie() && CookiesHelper.getCognitoCookie());

    const {
      proposal,
      view: { page },
      //eligibility,
      esignSrc,
    } = this.props;

    const isInstallerPage = !(page && page.startsWith('homeowner'));
    const isInstallerUser =
      !auth_helper.isShortAuth() &&
      (page === 'login' || page === 'resetPassword' || (isInstallerPage && !!sessionTokenExists));

    // if (page === 'qaHiddenV2') {
    //   return <QAHiddenV2Window></QAHiddenV2Window>;
    // }

    const config = this.getContent(sessionTokenExists, isInstallerUser);

    if (config === undefined) {
      return null;
    }

    const {
      content,
      loggedIn = true,
      productsTabs,
      financedRibbon,
      noRibbon,
      isProposalPage = false,
      hideFooter = false,
      footerFootnotes = false,
    } = config;

    let mainRibbonClass;

    if (financedRibbon && proposal && proposal.isFinanced) {
      mainRibbonClass = 'double-ribbon';
    }

    if (noRibbon) {
      mainRibbonClass = 'no-ribbon';
    }

    return (
      <div
        className="page-wrapper"
        ref={this.pageWrapper}
        style={{
          // width: '100%',
          // height: '100%',
          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='100px' width='500px' viewBox='0 0 100 500'><text transform='translate(00, 500) rotate(0)' fill='rgba(254,254,254, 1)' font-size='100'>${
            (window?.sessionStorage?.getItem('fetchTraceId') || '') + '  ' + (this?.props?.customer?.id || '')
          }</text></svg>")`,
          backgroundRepeat: 'repeat',
        }}
      >
        <div className="app-header">
          <div className="flap-display">
            <div style={{ position: 'absolute', zIndex: 10003 }}>
              <SnackbarProvider
                ref={this.notistackRef}
                action={(key) => (
                  <Button
                    className={'close-alert-toast'}
                    onClick={() => this.notistackRef?.current?.closeSnackbar(key)}
                    style={{ color: '#fff', fontSize: '16px' }}
                  >
                    <CloseIcon aria-hidden="true" />
                  </Button>
                )}
                maxSnack={3}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                classes={{
                  variantSuccess: 'success-flap-message',
                  variantError: 'error-flap-message',
                  variantWarning: 'error-flap-message',
                  variantInfo: 'success-flap-message',
                }}
                // TransitionComponent={Slide}
              >
                <Messages />
              </SnackbarProvider>
            </div>
            <ModalStack />
            <LogoBar {...{ loggedIn, isInstallerUser }} />
          </div>
          {this.customerPages.includes(page) && (
            <>
              {this.props.customer && <CustomerStatusBanner />}
              {/*{eligibility && eligibility?.creditCheck?.status === 'Expired' && (*/}
              {/*  <div*/}
              {/*    style={{ width: '100%', backgroundColor: 'salmon', textAlign: 'center', border: '1px solid gray' }}*/}
              {/*  >*/}
              {/*    Job expired on {moment(eligibility?.creditCheck?.expireDate, 'YYYY-MM-DD').format('MM/DD/YYYY')}*/}
              {/*  </div>*/}
              {/*)}*/}
              {/*{eligibility &&*/}
              {/*  eligibility?.creditCheck?.status !== 'Expired' &&*/}
              {/*  eligibility?.creditCheck?.expireDate &&*/}
              {/*  -moment().diff(eligibility?.creditCheck?.expireDate, 'days') <= 14 && (*/}
              {/*    <div*/}
              {/*      style={{*/}
              {/*        width: '100%',*/}
              {/*        backgroundColor: 'goldenrod',*/}
              {/*        textAlign: 'center',*/}
              {/*        border: '1px solid gray',*/}
              {/*      }}*/}
              {/*    >*/}
              {/*      Job expires in {-moment().diff(eligibility?.creditCheck?.expireDate, 'days')} day(s)*/}
              {/*    </div>*/}
              {/*  )}*/}
            </>
          )}
          {/*<UserAlerts />*/}
          {financedRibbon}
          {productsTabs}
        </div>
        <main className={mainRibbonClass}>
          {isProposalPage && (
            <div className="proposal-container">
              <ProposalWizard page={page}>
                <Suspense fallback={<PageSpinner />}>{content}</Suspense>
              </ProposalWizard>
            </div>
          )}
          {!isProposalPage && <Suspense fallback={<PageSpinner />}>{content}</Suspense>}
        </main>

        <Suspense fallback={<PageSpinner />}>
          <Scaffold />
        </Suspense>

        {esignSrc && (
          <Modal
            className={'qa-esign-modal'}
            fullScreen={true}
            title={'sign documents'}
            container={document.body}
            lastEvent={{ rect: { left: 0, top: 0 } }}
            headerActions={
              <Anchor id={'qa-esign-cancel'} onClick={() => Actions.setEsignIframeSrc(null)}>
                Close
              </Anchor>
            }
            modalMargin={'0px 0px 0px'}
          >
            {!/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && (
              <iframe
                id={'qa-esign-iframe'}
                style={{ height: '100%', width: '99.5%' }}
                title={'sign docs'}
                src={esignSrc[0]}
              ></iframe>
            )}
            {/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && (
              <div style={{ marginLeft: '10px', textAlign: 'center', fontSize: 'larger' }}>
                To continue with in-person signing, please click the link below. <br />
                <a href={esignSrc} target={'_blank'} rel="noreferrer">
                  {esignSrc}
                </a>
              </div>
            )}
          </Modal>
        )}

        {!hideFooter && (
          <Footer page={page} isInstallerUser={isInstallerUser}>
            {footerFootnotes && <Footnotes />}
          </Footer>
        )}
      </div>
    );
  }
}

const connectedPage = connect(
  ({
    locks,
    view,
    previousView,
    proposal,
    userPreferredEmail,
    user,
    userSettingValues,
    isGuestUser,
    customer,
    eligibility,
    esignSrc,
  }) => ({
    locks,
    view,
    previousView,
    proposal,
    userPreferredEmail,
    user,
    userSettingValues,
    isGuestUser,
    customer,
    eligibility,
    esignSrc,
  })
)(Page);

const PageWithDataLoaded = withDataLoaded({
  WithData: connectedPage,
  WithoutData: PageSpinner,
  emptyIsStillData: true,
  data: [userLoaderOptional],
});

export default PageWithDataLoaded;
